import React from 'react';
import Ellipse from '@ey/canvascoreservices/Ellipse';
import Userlistwrapper from '../Styles/AdminUserStyle';
import {labels} from '../../../../util/uiconstants';
import {useHistory} from 'react-router-dom';
import {MotifIcon, MotifIconButton} from '@ey-xd/motif-react';
import {IconoirTrash} from '@ey-xd/motif-icon';

function AdminUserItem(props) {
	const history = useHistory();

	const onManageRoleClick = () => {
		history.replace({
			pathname: history.location.pathname + '/userroles/' + props.data.userId,
			state: {customLabel: props.data.displayName}
		});
	};

	const onClickDeactivate = () => {
		props.onDeactivate(props.data);
	};

	return (
		<Userlistwrapper
			className={`manageaccessitemview ${
				props.data.isActive ? '' : 'inactive'
			}`}
		>
			<section className="userlistitem userdetail">
				<section className="initials motif-body2-default-light" onClick={onManageRoleClick}>
						<Ellipse content={props.data.displayName} noOfLines={1} />
				</section>
			</section>

			<section className="userlistitem useremail motif-body2-default-light">
				<Ellipse content={props.data.email} noOfLines={1} />
			</section>

			<section className="userlistitem contextmenu">
				<section className="context">
					<MotifIconButton
						type="button"
						aria-label="deactivate-icon-btn"
						onClick={onClickDeactivate}
						className="deactivate-user-edit-btn"
					>
						<MotifIcon
							name="deactivate"
							className="deactivate-icon"
							iconFunction={IconoirTrash}
							title={labels.deactivateButton}
							size={24}
						/>
					</MotifIconButton>
				</section>
			</section>
		</Userlistwrapper>
	);
}

export default AdminUserItem;
